import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { SectionStyled, ErrorMessageStyled } from "../../styles/common";
import { Container } from "../../components/Container/Container";
import { Loader } from "../../components/Loader/Loader";

export default function PaymentCancel() {
    const [params] = useSearchParams();
    const invoiceId = params.get("invoiceId") || params.get("token") || params.get("orderId");

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [paymentData, setPaymentData] = useState(null);

    useEffect(() => {
        if (!invoiceId) {
            setError("В URL отсутствует invoiceId.");
            setLoading(false);
            return;
        }

        const authToken = sessionStorage.getItem("accessToken");
        if (!authToken) {
            setError("Требуется авторизация.");
            setLoading(false);
            return;
        }

        const API_URL = `${process.env.REACT_APP_API_BASE_URL}/user/status/${invoiceId}`;

        axios
            .get(API_URL, {
                headers: { Authorization: `Bearer ${authToken}` },
            })
            .then(({ data }) => {
                console.log("💳 Payment status response:", data);
                setPaymentData(data);
            })
            .catch((err) => {
                console.error("❌ Ошибка при получении статуса оплаты:", err);
                setError(
                    err.response?.data?.message ||
                    err.message ||
                    "Ошибка получения статуса оплаты"
                );
            })
            .finally(() => setLoading(false));
    }, [invoiceId]);

    if (loading) {
        return (
            <SectionStyled>
                <Container>
                    <Loader />
                </Container>
            </SectionStyled>
        );
    }

    if (error) {
        return (
            <SectionStyled>
                <Container style={{ textAlign: "center", padding: "2rem 0" }}>
                    <ErrorMessageStyled>{error}</ErrorMessageStyled>
                    <Link
                        to="/shopping-cart"
                        style={{
                            display: "inline-block",
                            marginTop: 20,
                            textDecoration: "underline",
                        }}
                    >
                        Вернуться в корзину
                    </Link>
                </Container>
            </SectionStyled>
        );
    }

    const { success, status, amount, currency, invoiceId: id, cardType, cardMask } =
    paymentData || {};

    const isSuccess = success && status === "CHARGE";

    return (
        <SectionStyled>
            <Container style={{ textAlign: "center", padding: "2rem 0" }}>
                {isSuccess ? (
                    <>
                        <h2>🎉 Оплата прошла успешно!</h2>
                        <p>
                            Сумма: <strong>{amount} {currency}</strong>
                        </p>
                        <p>
                            Карта: {cardType} ({cardMask})
                        </p>
                        <p>Номер счёта: {id}</p>

                        <Link
                            to="/"
                            style={{
                                display: "inline-block",
                                marginTop: 20,
                                textDecoration: "underline",
                            }}
                        >
                            На главную
                        </Link>
                    </>
                ) : (
                    <>
                        <h2>😞 Платёж не прошёл</h2>
                        <p>
                            Статус: <strong>{status}</strong>
                        </p>
                        <p>
                            Сумма: {amount} {currency}
                        </p>
                        <p>Проверьте данные карты или попробуйте снова.</p>

                        <Link
                            to="/shopping-cart"
                            style={{
                                display: "inline-block",
                                marginTop: 20,
                                textDecoration: "underline",
                            }}
                        >
                            Вернуться в корзину
                        </Link>
                    </>
                )}
            </Container>
        </SectionStyled>
    );
}
